import { Stepper, type StepperProps } from '@mui/material';
import { SxProps, Theme } from '@mui/system';

const rootStepperAlign: SxProps<Theme> = {
  alignItems: 'flex-start',
};

/**
 * Horizontal MUI `Stepper` for member consent flows, with the root row aligned to `flex-start`
 * so step icons and connectors line up (matches prior `Stepper` `sx` in `ConsentIdentityStepper`).
 *
 * @param props - MUI `Stepper` props; any `sx` is merged after the default alignment
 * @returns A `Stepper` with root `alignItems: 'flex-start'`, plus merged `sx`
 */
export const ConsentMemberStepper = (props: StepperProps) => {
  const { sx, ...rest } = props;
  const mergedSx: SxProps<Theme> = [rootStepperAlign, ...(Array.isArray(sx) ? sx : sx != null ? [sx] : [])];
  return <Stepper {...rest} sx={mergedSx} />;
};
